import { HTMLFromRichText, PrismicLink, PrismicSharpImage, TextFromRichText } from './PrismicTypes';

export const TEXT_IMAGE_LAYOUT = 'PrismicGenericTemplateDataBodyTextImageLayout';

export interface TextImageLayoutPrimary {
  layout_title: TextFromRichText;
  content?: HTMLFromRichText;
  primary_button_text?: TextFromRichText;
  primary_button_link?: PrismicLink;
  secondary_button_text?: TextFromRichText;
  secondary_button_link?: PrismicLink;
  image?: PrismicSharpImage;
  variant?: 'white' | 'mint' | 'grey';
  layout_variant?: 'left' | 'right';
}

export interface TextImageLayoutContent {
  __typename: typeof TEXT_IMAGE_LAYOUT;
  primary: TextImageLayoutPrimary;
}
